import {createFeatureSelector, createSelector} from '@ngrx/store';
import {adapter, featureKey} from '../_reducers/template-field-entity.reducer';
import {filterComplexTemplateFields} from '../_reducers/filterComplexTemplateFields.fn';
import {FieldTypes} from '../_interface/field-types.enum';
import {Dictionary} from '@ngrx/entity';
import {IFullTemplateField} from '../_interface/itemplate-field';

export const entityState = createFeatureSelector(featureKey);
export const selectAll = createSelector(entityState, adapter.getSelectors().selectAll);
export const selectComplexFields = createSelector(selectAll, fields => filterComplexTemplateFields(fields));
export const selectComplexPrototypes = createSelector(
	selectComplexFields,
		fields => fields.filter(item => item.fieldType === FieldTypes.prototype)
);

export const templateFieldsLoaded = createSelector(entityState, ({loaded}) => loaded);
export const selectEntities = createSelector(entityState, adapter.getSelectors().selectEntities);
export const selectOneEntity = (id: string | number) => {
	return createSelector(selectEntities, (e: Dictionary<IFullTemplateField>) => e[id]);
};

export const selectMultipleEntities = (ids: string[]) => {
	return createSelector(selectEntities, (e: Dictionary<IFullTemplateField>) => ids.map(id => e[id]));
};
